export class PopupWorkingSet {
    constructor(announcements = [], startAt = null) {
        this.announcements = [...announcements]

        const requested = this.announcements.findIndex((one) => one.documentId === startAt)
        this.index = requested === -1 ? 0 : requested
    }

    get current() {
        return this.announcements[this.index] ?? null
    }

    get canNavigate() {
        return this.announcements.length > 1
    }

    next() {
        return this.moveBy(1)
    }

    previous() {
        return this.moveBy(-1)
    }

    moveBy(step) {
        const count = this.announcements.length
        if (count === 0) {
            return null
        }

        this.index = (this.index + step + count) % count

        return this.current
    }
}
